export default "//file.bilionpass.com/japandx-portal/0.1.22/static/img/balloon.cf97106b-55d3e3.svg";